<template>
  <div class="new-product-accessory-summary">
    <template v-if="selectedItems.length">
      <span
        v-for="(selectedItem, index) in selectedItems"
        :key="`${selectedItem.productId || selectedItem.value}_${index}`"
        class="summary-badge"
      >
        {{ selectedItem.quantity }}x {{ localizedValue(selectedItem.title1) || localizedValue(selectedItem.name) }}
      </span>
    </template>
    <span v-else class="text-muted">{{ translations.value_none || 'keine gewählt' }}</span>
  </div>
</template>

<script>
export default {
  name: 'NewProductAccessorySummary',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    selectedItems() {
      return this.item?.selectedItems || []
    }
  },
  methods: {
    localizedValue(value) {
      if (value == null) {
        return ''
      }

      if (typeof value === 'string') {
        return value
      }

      const locale = this.$i18n.locale
      return value[locale] || value[locale.split('-')[0]] || Object.values(value)[0] || ''
    }
  }
}
</script>

<style lang="scss">
.new-product-accessory-summary {
  display: flex;
  flex-wrap: wrap;
  gap: $spacer * 0.25;

  .summary-badge {
    display: inline-flex;
    align-items: center;
    max-width: 220px;
    padding: 0.1rem 0.35rem;
    border-radius: $border-radius-sm;
    background-color: $gray-200;
    font-size: $font-size-sm;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
